module.exports = __webpack_public_path__ + "static/media/3.ac4b7676.png";